import React, { useRef } from 'react';
import './FileUpload.css';

const FileUpload = ({ onFileUpload, loading }) => {
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file && file.type === 'application/json') {
      onFileUpload(file);
    } else {
      alert('Please select a valid JSON file.');
    }
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file && file.type === 'application/json') {
      onFileUpload(file);
    } else {
      alert('Please drop a valid JSON file.');
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  return (
    <div className="file-upload-container">
      <div 
        className={`file-upload-area ${loading ? 'loading' : ''}`}
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={handleClick}
      >
        <input
          ref={fileInputRef}
          type="file"
          accept=".json"
          onChange={handleFileChange}
          style={{ display: 'none' }}
        />
        
        {loading ? (
          <div className="loading-content">
            <div className="spinner"></div>
            <p>Processing file...</p>
          </div>
        ) : (
          <div className="upload-content">
            <div className="upload-icon">📁</div>
            <h3>Upload Redirects JSON File</h3>
            <p>Drag and drop your <code>prod_website_redirects_08072025.json</code> file here</p>
            <p>or click to browse</p>
            <div className="file-format-info">
              <small>Supported format: JSON files with redirect objects containing "source", "target", and "status" fields</small>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default FileUpload; 